var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFrontLeftLeg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 34,
    height: 78,
    viewBox: "0 0 34 78",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.88524 7.79644C3.5468 9.10773 1.01756 4.51824 1.01756 4.51824C1.01756 4.51824 1.01774 5.5017 0.689705 8.7799C0.361674 12.0581 0.254956 21.9594 2.23552 25.4987C4.43685 29.4326 6.26268 37.5188 6.91832 41.8897C7.70509 48.1839 7.68323 51.2872 7.57396 52.0521C7.04945 53.3634 7.57396 54.5654 7.90178 55.0025C6.5905 61.8867 7.57396 62.8702 10.5243 64.8371C12.8846 66.4106 13.6933 67.2411 13.8025 67.4597C19.0477 74.3439 19.7033 74.3439 21.0146 74.3439C22.0636 74.3439 22.763 74.9995 22.9815 75.3273C25.8663 78.7367 27.6803 76.7479 28.2266 75.3273C29.2756 76.9009 30.1935 75.983 30.5214 75.3273C31.5704 75.8519 32.0512 75.1088 32.1605 74.6717C32.4227 74.6717 32.7068 74.4532 32.8161 74.3439C33.0784 74.0816 32.4883 73.3604 32.1605 73.0326H32.4883C33.5373 72.2458 31.177 70.7379 29.8657 70.0822C27.4617 67.2411 22.0636 60.5754 19.7033 56.6416C16.7529 51.7243 17.4086 49.4296 17.4086 48.1183V27.4656C17.6708 12.2548 14.4581 1.57218 14.3649 1.24436C14.2716 0.916544 14.2237 6.48515 8.88524 7.79644Z",
    stroke: "#202E5F",
    strokeWidth: 0.65564,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFrontLeftLeg);
export default __webpack_public_path__ + "static/media/FrontLeftLeg.0c2ae0a0045c2f06f16e8877ff57ac24.svg";
export { ForwardRef as ReactComponent };